import styled from "styled-components";
import Paragraph from "antd/es/typography/Paragraph";
import Text from "antd/es/typography/Text";

export const Card = styled.div`
  padding: 20px 16px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.13);
  border: 1px solid ${({ theme }) => theme.borders.gray};
  border-radius: 20px;
`;

export const ImageContainer = styled.div`
  display: block;
  position: relative;
  width: 100%;
  height: 175px;
  margin: auto;
  margin-bottom: 20px;
`;

export const Image = styled.img`
  position: aboslute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  object-fit: contain;
`;

export const Title = styled(Paragraph)`
  font-size: 16px;
  margin-bottom: 50px;
`;

export const Price = styled(Text)`
  display: block;
  color: ${({ theme }) => theme.colors.primary};
  text-align: right;
`;
